module.exports = __webpack_public_path__ + "img/banner_bag_big_5cb8743.png";